import { useContext, useEffect, useState } from "react";
import "./LangSelect.scss";
import flagRU from "../../assets/ru.svg";
import flagUS from "../../assets/us.svg";
import { LangContext } from "../../context/langContext";

const langs = [
  ["RU", flagRU],
  ["EN", flagUS],
];

const LangSelect = ({ className, changeLang, isDropdown }) => {
  const [isOpen, setIsOpen] = useState(false);
  const lang = useContext(LangContext);
  const [currentLang, setCurrentLang] = useState(langs[0]);

  function handleLangSelect(newLang) {
    changeLang(newLang);
    setCurrentLang(newLang);
    setIsOpen(false);
  }

  function renderLangs() {
    return langs.map((language) => {
      if (currentLang[0] !== language[0]) {
        return (
          <li key={language[0]}>
            <button
              type="button"
              className="lang-select__option"
              onClick={() => {
                handleLangSelect(language);
              }}
            >
              <span
                className="flag-icon"
                style={{ backgroundImage: `url(${language[1]})` }}
              />
              {language[0]}
            </button>
          </li>
        );
      }
      return null;
    });
  }

  useEffect(() => {
    setCurrentLang(langs.find((l) => l[0] === lang));
  }, [lang]);

  if (isDropdown) {
    return (
      <div className={`lang-select ${className}`}>
        <button
          type="button"
          className="lang-select__current"
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <span
            className="flag-icon"
            style={{ backgroundImage: `url(${currentLang[1]})` }}
          />
          {currentLang[0]}
          <span
            className={`icon-arrow-down lang-select__arrow ${
              isOpen && "lang-select__arrow_open"
            }`}
          />
        </button>
        <ul
          className={`lang-select__options ${
            isOpen ? "lang-select__options_open" : "lang-select__options_closed"
          }`}
        >
          {renderLangs()}
        </ul>
      </div>
    );
  }
  return (
    <div className={`lang-select-short ${className}`}>
      <ul className="lang-select-short__langs">
        {langs.map((language) => (
          <li key={language[0]}>
            <button
              type="button"
              className="lang-select-short__lang"
              onClick={() => {
                handleLangSelect(language);
              }}
            >
              <span
                className="flag-icon"
                style={{ backgroundImage: `url(${language[1]})` }}
              />
              {language[0]}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LangSelect;
